import * as R from 'ramda';
export const parseIfNumber = R.cond([
    [R.equals('0'), R.always(0)],
    [parseFloat, parseFloat],
    [R.T, R.identity],
]);
export default parseIfNumber;
